<app-header></app-header>
<div class="container-fluid bg-terms-conditions" [style.font-family]="'var(--vex-font)'">
  <div class="container py-24">
    <p class="text-center text-5xl font-bold text-white">Enroll</p>
    <p class="pt-8 text-3xl text-center font-bold text-white">Terms of Use and Privacy Policy</p>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-xl text-zinc-700">Welcome to Enroll! We strive to provide excellent service and satisfaction to our customers. Our
      goal is to give
      our clients outstanding service and happiness. We work hard to deliver the greatest user experience and client
      contentment. We are aware, nonetheless, that there might be circumstances in which you must stop using a service
      or request a refund. The standards and procedures for such circumstances are outlined in this Refund and
      Cancellation Policy.
      This Refund Policy describes how Enroll, an admission management system, handles refunds. The practices of
      businesses that Enroll does not own, control, or manage, as well as any third-party service and/or product
      suppliers under contract, as well as any third-party websites that link from Enroll websites, are not covered by
      this refund policy.</p>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container bg-heading rounded-2xl p-8">
    <p class="text-3xl text-white text-center">Please be informed that your privacy is always our priority!</p>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-3xl font-semibold">1. Information We May Collect</p>
    <p class="pt-6 text-xl text-zinc-700">Through our communications with you and the use of our goods and services, Enroll gathers
      personal
      information from you. A portion of this data is directly provided by you, and the remainder is obtained through
      data collection about your interactions, usage, and experiences with our services. The context of your
      interactions with Enroll, as well as the decisions you make regarding your privacy settings, the goods and
      features you use, and other factors, determine what information we collect. We also acquire information about
      you from outside sources.
      Regarding the technologies you use and the data you disclose, you have options. You have the option to refuse
      requests from us for personal information. For many of our products to function and offer you a service, some
      basic personal data is required.</p>
    <p class="text-xl font-semibold pt-4">We may collect the following types of information when you visit our website
      or use our services:</p>
    <ul class="list-disc pt-8 text-zinc-700">
      <li><p class="text-xl"><b>Personal Data:</b> You or our Customer (for example, your employer) must provide Enroll
        with an email
        address, phone number, password, domain, and/or other account setup details to create or update a Workspace
        account. You must also provide Enroll with billing information, such as credit card, banking, and/or billing
        address.</p>
      </li>
      <li><p class="text-xl"><b>Usage Data:</b>Metadata that adds further context to an Authorized User's use of the
        Services is generated when the Authorized User interacts with the Services. Details on how you utilize our
        services and website, including the pages you visit, the browser you use, your IP address, and the amount of
        time you spend on each page.</p>
      </li>
      <li><p class="text-xl"><b>Cookies:</b> Enroll assists in gathering Additional Information by utilizing a range of
        cookies and related technologies on our Websites and Services. To improve your experience, personalize content,
        and track website traffic, we may use cookies and related technologies.</p>
      </li>
      <li><p class="text-xl"><b>Third-party Data:</b> Enroll uses data from various sources to enhance its business
        information, including customer lists, website visitors, and marketing campaigns. This data can be aggregated to
        provide aggregate-level data or more precise insights into campaign effectiveness.</p>
      </li>
      <li><p class="text-xl"><b>Additional Information Provided:</b>Other information is collected when you submit it to
        our websites or through other means, such as responses or opinions from focus groups, contests, activities,
        events, feedback about our products or services, or job application information.</p>
      </li>
    </ul>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-3xl font-semibold">2. How We Use Your Information</p>
    <p class="pt-6 text-xl text-zinc-700">Enroll shall utilize customer data in compliance with the terms specified by the customer,
      the customer's use of the services' functionality, any applicable terms in the customer agreement, and as mandated
      by applicable legislation.</p>
    <p class="text-xl font-semibold pt-4">Enroll uses the information we gather to give you engaging, personalized
      experiences. Specifically, we utilize data to:</p>
    <ul class="list-disc pt-8 text-zinc-700">
      <li><p class="text-xl">Deliver our products or services including maintenance, security, and troubleshooting;
        additionally, we offer assistance. When sharing data is necessary to deliver the service or complete the
        transactions you have requested, it also involves such sharing.</p>
      </li>
      <li><p class="text-xl">Develop and enhance our offerings.</p>
      </li>
      <li><p class="text-xl">Customize our offerings and offer advice.</p>
      </li>
      <li><p class="text-xl">Promote and market to you by delivering offers that are pertinent to you, sending out
        promotional emails, and focusing on advertising.</p>
      </li>
    </ul>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-3xl font-semibold">3. Sharing Your Information</p>
    <p class="pt-6 text-xl text-zinc-700">With your permission, to fulfill any transaction, or to deliver any goods you have asked for
      or approved, we disclose your personal information. Customers set their own guidelines and procedures for
      information sharing and disclosure to outside parties. Enroll does not influence the sharing or disclosure of
      Information decisions made by Customers or other parties.</p>
    <p class="pt-6 text-xl text-zinc-700">In conformity with applicable laws and legal procedures, Enroll may share and disclose
      Information in response to a customer's requests and with the proper authorization. This includes any terms that
      may be relevant to the customer agreement and the customer's usage of the services' functionality.</p>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-3xl font-semibold">4. Security of Your Information</p>
    <p class="pt-6 text-xl text-zinc-700">We employ security measures and make reasonable efforts to protect your personal information
      from unauthorized access, use, or disclosure. We respect data privacy and are aware of the client's requirement to
      maintain the privacy of applicant information. Enroll in the world's most secure cloud computing program by
      renting a highly secure cloud server architecture. Our cloud platform helps safeguard your data from unwanted
      access, use, loss, destruction, or exposure by guaranteeing secure communications between servers and
      browsers.</p>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-3xl font-semibold">5. Your Choices & Rights</p>
    <p class="pt-6 text-xl text-zinc-700">You may update, correct, or delete your account information at any time by contacting us.
      When we request your personally identifiable information, we provide you the option to "opt-out" of having it used
      for specific purposes. You have the option to opt out of some of these disclosures if you would rather that we not
      release the information you have given us to third parties.</p>
    <p class="text-xl text-zinc-700">You can choose not to receive our newsletters by emailing us (see "unsubscribe" below) or by
      following the instructions in each newsletter or message if you would like to stop receiving them. You can ask for
      your personal information to be deleted if you no longer want us to use it.</p>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-3xl font-semibold">6. Children's Privacy</p>
    <p class="pt-6 text-xl text-zinc-700">You must have your parent or guardian read and agree to the agreement below if you are under
      the age of 18. You do not have permission to use this website if you do not get your parent or guardian to read
      and agree to this. Privacy policy (this “Agreement”): Please read carefully before using any of Enroll's
      services.</p>
    <p class="text-xl text-zinc-700">You acknowledge that you have read this agreement and that you accept and will be bound by it by
      using this platform, by seeing, visiting, using, or engaging with any banner, pop-up, or advertisement that
      appears on it, or by using any services that Enroll offers. If any of the terms of this agreement are not
      unconditionally accepted by you, you may not use the services. </p>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-3xl font-semibold">7. Security of Your Information</p>
    <p class="pt-6 text-xl text-zinc-700">Enroll reserves the right to periodically modify these terms of use and privacy statements.
      Laws, rules, and industry standards change, and we might have to adjust our services or business model to
      accommodate these changes. To keep you informed, we will announce any changes on this page and invite you to read
      our Privacy Policy. Enroll will give you further notice, for example, via email or through the Services, if we
      make changes that significantly affect your privacy rights. You ought to cancel your Services account if you don't
      agree with the modifications made to this privacy statement. If you would want to ask that Personal Data that is
      in their possession, be deleted, get in touch with customer service. Regarding the Information Technology Act of
      2000, this document is a record that is kept electronically. Since it is produced by a computer system, no digital
      or physical signatures are needed.</p>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4">
    <p class="text-3xl font-semibold">8. Preservation of private data</p>
    <p class="pt-6 text-xl text-zinc-700">For as long as it takes to enable you to use the Services and for related, lawful, and
      crucial business purposes—which might include, but are not limited to, enhancing our Services, resolving technical
      difficulties, and handling disputes—we will retain any personal information we obtain from you. Even if you
      request that your personal information be deleted, we might still need to keep some or all of it to enforce our
      agreements, handle disputes, and comply with legal requirements.
      As a Customer, you are hereby informed that: (i) following applicable laws, you must notify your Leads about how
      you or we (on your behalf) handle and store any data that we may collect from them through one of our Services;
      and (ii) if you discontinue using a Service, we may, unless legally prohibited, remove all information that you
      have provided or collected from us, including Lead information, from our servers.</p>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-3xl font-semibold">9. Cookies Management</p>
    <p class="pt-6 text-xl text-zinc-700">Cookies are little text files that are stored on your device and are used to store
      information that a web server on the domain that set the cookie may retrieve. Cookies and related technologies are
      used by us to store and respect your preferences and settings, make it easier for you to log in, deliver
      interest-based advertising, stop fraud, monitor how well our products work, and accomplish other legal
      objectives.</p>
    <p class="text-xl text-zinc-700">Social media cookies, which display advertisements and content to you based on your social media
      profiles and activities on our websites, are an example of third-party cookies. Analytics cookies are used by us
      to better understand how you and other users interact with our websites, allowing us to make improvements and
      enabling third parties to enhance their own offerings; cookies for advertising purposes, which provide you with
      relevant adverts; and Essential cookies needed for the operation of this website. When necessary, we get your
      permission before deploying or utilizing optional cookies that aren't</p>
    <p class="text-xl font-semibold">(i) Absolutely required to operate the website</p>
    <p class="text-xl font-semibold">(ii) Used to help with communication.</p>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-3xl font-semibold">10. Contact Us</p>
    <p class="pt-6 text-xl text-zinc-700">If you have any questions about this Privacy Policy, please contact us at
      <a href="mailto:support@volmint.com"><u class="font-semibold">support&#64;volmint.com</u></a>.
      You agree to be bound by this Privacy Policy by using the Platform and providing Your Personal Information, and
      you confirm that you have read and understand it.</p>
  </div>
</div>
<div class="above-footer mt-10 md:mt-12 py-12" [style.font-family]="'var(&#45;&#45;vex-font)'">
  <div class="container">
    <div class="m-auto text-center">
      <img src="./assets/images/img-group.png" alt="" class="mx-auto">
      <h3 class="mt-5 text-white text-xl font-medium">
        Need any further assistance?
      </h3>
      <p class="mt-4 text-white ">
        Feel free to reach out for any inquiries or assistance.
      </p>
      <button type="button" class="mt-5 px-3 py-2 bg-white text-[#6752A9] rounded" (click)="goTo('/contact-us')">
        Book an appointment now!
      </button>
    </div>
  </div>
</div>
<app-footer></app-footer>
